import * as React from "react";
import { useCallback } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Icon from "components/common/Icon";
import Menu from "../Menu";
const IconWrapper = styled.div`
  display: inline-flex;
  min-width: 20px;
  margin-right: 5px;
  justify-content: center;
  align-items: center;
`;
const CustomMenuItem = ({
  children = void 0,
  className = void 0,
  disabled = false,
  divider = false,
  eventKey = void 0,
  header = false,
  href = void 0,
  icon = void 0,
  id = void 0,
  onClick = void 0,
  onSelect = void 0,
  rel = void 0,
  target = void 0,
  title = void 0,
  "data-tab-id": dataTabId = void 0,
  component = void 0,
  closeMenuOnClick = void 0
}) => {
  const callback = onClick != null ? onClick : onSelect;
  const _onClick = useCallback(() => callback == null ? void 0 : callback(eventKey), [callback, eventKey]);
  if (divider) {
    return /* @__PURE__ */ React.createElement(Menu.Divider, { role: "separator", className, id });
  }
  if (header) {
    return /* @__PURE__ */ React.createElement(Menu.Label, { role: "heading", className, id }, children);
  }
  const sharedProps = {
    className,
    "data-tab-id": dataTabId,
    disabled,
    icon: icon ? /* @__PURE__ */ React.createElement(IconWrapper, null, /* @__PURE__ */ React.createElement(Icon, { name: icon })) : null,
    id,
    onClick: _onClick,
    title,
    closeMenuOnClick
  };
  if (href) {
    return /* @__PURE__ */ React.createElement(Menu.Item, { component: Link, to: href, rel, target, ...sharedProps }, children);
  }
  return /* @__PURE__ */ React.createElement(Menu.Item, { component, ...sharedProps }, children);
};
export default CustomMenuItem;
